import { combineClasses } from "@/lib/utils";
import styles from "./CustomTabs.module.scss";

export interface CustomTab {
  label: string;
  value: string;
  count?: number;
}

export interface CustomTabsProps {
  tabs: CustomTab[];
  activeTab: string;
  onChange: (value: string) => void;
}

// A segmented pill control where each tab (besides the implicit "show
// everything" one) can carry a count badge — e.g. "The Marquee 6". Distinct
// from CustomHeader's own `tabs` (plain labels, no counts, tied to the
// Table/search toolbar) — this is a standalone control for any page that
// needs a category filter row, e.g. pages/Gatherings.
const CustomTabs = ({ tabs, activeTab, onChange }: CustomTabsProps) => (
  <div className={styles.tabs}>
    {tabs.map((tab) => (
      <button
        key={tab.value}
        type="button"
        className={combineClasses(styles.tab, activeTab === tab.value && styles.tabActive)}
        onClick={() => onChange(tab.value)}
      >
        {tab.label}
        {typeof tab.count === "number" && <span className={styles.tabCount}>{tab.count}</span>}
      </button>
    ))}
  </div>
);

export default CustomTabs;
